import { formatDate } from '../../utilities';
import { CampaignName } from '../../templates';
import { contactColumn } from '../../templates';
import { useMonitoring } from './useGeneralMonitoring';
import { ContactState, MonitoringTemplate } from '../../templates';
import type { ItemType } from './useGeneralMonitoring';

const GeneralMonitoring = () => {
  const monitoringResult = useMonitoring();

  return (
    <MonitoringTemplate<ItemType>
      listResult={monitoringResult}
      totalCount={monitoringResult.pagination.totalItems}
      columns={[
        contactColumn,
        {
          header: 'State',
          sortName: 'latest_contact_state',
          cellClassName: 'max-w-[15rem]',
          getValue: ({
            campaign_id,
            latest_contact_state,
            latest_contact_state_enum,
          }) => (
            <ContactState
              className="max-w-[13rem]"
              campaignId={campaign_id}
              latest_contact_state={latest_contact_state_enum}
              latest_contact_state_label={latest_contact_state}
            />
          ),
        },
        {
          header: 'Next Task',
          sortName: 'next_task_time',
          cellClassName: 'text-small',
          getValue: ({ next_task_time, next_task_channel }) => (
            <div className="flex flex-col">
              <div>{next_task_channel}</div>
              <div className="text-tiny text-textLight">
                {formatDate(next_task_time)}
              </div>
            </div>
          ),
        },
        {
          header: 'Campaign',
          sortName: 'campaign_name',
          cellClassName: 'text-small',
          getValue: ({ campaign_id, campaign_name }) => (
            <CampaignName
              id={campaign_id}
              name={campaign_name}
              withId={false}
              withMonitoringLink
              withMonitoringLinkIcon={false}
            />
          ),
        },
      ]}
    />
  );
};

export default GeneralMonitoring;
